/**
 * @file Discover Album Folder Purchase view.
 */

import React from 'react';

import AlbumFolderPurchaseSelectIdentitiesContainer from '../../containers/purchase/album-folder-purchase/AlbumFolderPurchaseSelectIdentitiesContainer';

const AlbumFolderPurchaseSelectIdentitiesView = props => (
  <AlbumFolderPurchaseSelectIdentitiesContainer {...props} />
);

export default AlbumFolderPurchaseSelectIdentitiesView;
